const DocumentMSStyle = (theme) => ({
  container: {
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
    fontFamily: 'Montserrat',
    backgroundColor: '#F9FAFB',
    minHeight: '100vh',
    '& .location': {
      display: 'none !important',
    },
    '& .location-text': {
      display: 'none !important',
    },
  },
  header: {
    marginBottom: '24px',
  },
  title: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#131C4C',
    fontFamily: 'Montserrat',
    margin: 0,
    letterSpacing: '-0.5px',
    lineHeight: '1.2',
  },
  card: {
    borderRadius: '16px',
    padding: '32px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
  },
  // Summary Cards
  summaryCard: {
    padding: '24px',
    borderRadius: '14px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #E5E7EB',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.12)',
      borderColor: '#131C4C',
    },
  },
  summaryValue: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#131C4C',
    fontFamily: 'Montserrat',
    marginBottom: '4px',
  },
  summaryLabel: {
    fontSize: '14px',
    color: '#6E759A',
    fontFamily: 'Montserrat',
  },
  // Buttons
  button: {
    backgroundColor: '#0F1638',
    color: '#FFFFFF',
    textTransform: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#0A0F25',
      boxShadow: '0 2px 8px rgba(15, 22, 56, 0.2)',
    },
    '&:disabled': {
      backgroundColor: '#BCC0D5',
      color: '#FFFFFF',
    },
  },
  buttonSecondary: {
    backgroundColor: 'transparent',
    color: '#131C4C',
    textTransform: 'none',
    borderRadius: '8px',
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    border: '1px solid #BCC0D5',
    '&:hover': {
      backgroundColor: '#F9F9F9',
      borderColor: '#131C4C',
    },
  },
  // Tables
  table: {
    '& .MuiTableCell-root': {
      fontFamily: 'Montserrat',
      borderBottom: '1px solid #E0E0E0',
    },
  },
  tableHeader: {
    backgroundColor: '#F9F9F9',
    fontSize: '14px',
    fontWeight: 600,
    color: '#131C4C',
    fontFamily: 'Montserrat',
    padding: '16px',
    textTransform: 'none',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#F9F9F9',
    },
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    fontSize: '14px',
    color: '#131C4C',
    fontFamily: 'Montserrat',
    padding: '16px',
  },
  // Form Elements
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#131C4C',
    fontFamily: 'Montserrat',
    marginBottom: '8px',
    display: 'block',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      color: '#131C4C',
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        borderColor: '#BCC0D5',
      },
      '&:hover fieldset': {
        borderColor: '#131C4C',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#131C4C',
        borderWidth: '2px',
      },
    },
    '& .MuiInputBase-input': {
      padding: '12px 16px',
    },
  },
  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      color: '#131C4C',
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        borderColor: '#BCC0D5',
      },
      '&:hover fieldset': {
        borderColor: '#131C4C',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#131C4C',
        borderWidth: '2px',
      },
    },
  },
  // File Upload
  fileUploadArea: {
    border: '2px dashed #BCC0D5',
    borderRadius: '9px',
    padding: '40px',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#F9F9F9',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#131C4C',
      backgroundColor: '#F5F5F5',
    },
  },
  // Status Badges
  statusBadge: {
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Montserrat',
    padding: '4px 12px',
    borderRadius: '12px',
  },
  statusAssigned: {
    backgroundColor: '#FFF3E0',
    color: '#FF9800',
  },
  statusSentViaJiffy: {
    backgroundColor: '#E3F2FD',
    color: '#0F1638',
  },
  statusCollectedViaJiffy: {
    backgroundColor: '#E8F5E9',
    color: '#4CAF50',
  },
  statusSentViaOther: {
    backgroundColor: '#F3E5F5',
    color: '#9C27B0',
  },
  statusProcessing: {
    backgroundColor: '#E3F2FD',
    color: '#0F1638',
  },
  statusCompleted: {
    backgroundColor: '#E8F5E9',
    color: '#4CAF50',
  },
  statusPending: {
    backgroundColor: '#FFF3E0',
    color: '#FF9800',
  },
  statusInProgress: {
    backgroundColor: '#E3F2FD',
    color: '#0F1638',
  },
  // Filter Container
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '24px',
    flexWrap: 'wrap',
  },
  filterItem: {
    minWidth: '200px',
  },
  // Error and Success Messages
  error: {
    backgroundColor: '#FFEBEE',
    color: '#C62828',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'Montserrat',
    marginBottom: '16px',
  },
  success: {
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    padding: '12px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'Montserrat',
    marginBottom: '16px',
  },
  // Loading
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
  },
  // Empty State
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
  },
  emptyStateIcon: {
    fontSize: '64px',
    marginBottom: '16px',
  },
  emptyStateText: {
    fontSize: '16px',
    color: '#6E759A',
    fontFamily: 'Montserrat',
  },
});

export default DocumentMSStyle;
